module.exports = __webpack_public_path__ + "media/emails/header-blue-5a9e43b4.png";